import { render } from "./DashboardTraining.vue?vue&type=template&id=42f1efe2&scoped=true"
import script from "./DashboardTraining.vue?vue&type=script&lang=js"
export * from "./DashboardTraining.vue?vue&type=script&lang=js"

import "./DashboardTraining.vue?vue&type=style&index=0&id=42f1efe2&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f1efe2"]])

export default __exports__